import { Box } from "@mantine/core";
import React from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../auth/AuthProvider";
import { SideNavTree } from "../../components/common/navigation";
import { ROUTES } from "../../constants/routes";
import { REPORT_PROFILES } from "./config/reportProfiles";

const REPORTS_NAV_STORAGE_KEY = "cv-portal:reports-nav-collapsed";

// The Reports nav shell — left-side tree (By Technology / By Certificates) + the routed
// report page. AppShell/Header are wired at the route level in App.tsx, same as
// EmployeeOverview — this component owns only the Reports-specific layout below them.
// SideNavTree manages its own width (expanded/collapsed) — this Box only needs flexShrink
// so the content area doesn't compress it.
export const Reports: React.FC = () => {
  const { userRole } = useAuth();

  return (
    <Box style={{ display: "flex", gap: "var(--mantine-spacing-md)", alignItems: "flex-start" }}>
      <Box style={{ flexShrink: 0 }}>
        <SideNavTree
          items={REPORT_PROFILES}
          basePath={ROUTES.REPORTS}
          userRole={userRole}
          storageKey={REPORTS_NAV_STORAGE_KEY}
        />
      </Box>
      <Box style={{ flex: 1, minWidth: 0 }}>
        <Outlet />
      </Box>
    </Box>
  );
};
